export const ptBRLists = {
  title: 'Listas',
  loading: 'Carregando listas…',
  noCollections: 'Nenhuma lista ainda',
  noCollectionsHint: 'Crie sua primeira lista para começar a adicionar itens.',
  newList: 'Nova lista',
  createDialogTitle: 'Nova lista',
  nameLabel: 'Nome da lista',
  namePlaceholder: 'ex. Mercado',
  create: 'Criar',
  cancel: 'Cancelar',
  validationNameRequired: 'O nome é obrigatório',
  quickAddPlaceholder: 'Adicionar um item…',
  quickAddNoSuggestions: 'Nenhuma sugestão',
  quickAddCreate: 'Adicionar "{{title}}"',
  add: 'Adicionar',
  noItems: 'Nenhum item ainda — adicione um acima.',
  loadError: 'Falha ao carregar as listas',
  toastCollectionCreated: 'Lista criada',
  toastCollectionCreatedError: 'Falha ao criar a lista',
  toastItemAdded: 'Item adicionado',
  toastItemAddedError: 'Falha ao adicionar o item',
  toastItemReopened: 'Item reaberto',
  toastItemAlreadyOnList: 'Já está na lista',
  toastItemDuplicateTitle: 'Já existe um item com esse nome na lista',
  pasteDialogTitle: 'Adicionar vários itens',
  pasteDialogDescription: 'Revise os itens antes de adicioná-los à sua lista.',
  pasteItemPlaceholder: 'Item',
  pasteRemoveRow: 'Remover item',
  pasteConfirm: 'Adicionar {{total}} itens',
  toastPasteAdded: '{{total}} itens adicionados',
  toastPastePartial: '{{added}} adicionados, {{failed}} falharam',
  toastPasteError: 'Falha ao adicionar os itens',
  toastItemToggledError: 'Falha ao atualizar o item',
  clearCompleted: 'Limpar concluídos',
  refresh: 'Atualizar',
  listUpdated: 'Lista atualizada',
  undo: 'Desfazer',
  toastCleared: 'Itens concluídos removidos',
  toastClearError: 'Falha ao remover os itens concluídos',
  toastRestored: 'Itens restaurados',
  toastRestoreError: 'Falha ao restaurar os itens',
  toastReorderError: 'Falha ao reordenar os itens',
  dragHandleLabel: 'Arraste para reordenar',
  picture: 'Foto',
  pictureAdd: 'Adicionar foto',
  pictureView: 'Ver foto',
  pictureReplace: 'Substituir',
  pictureRemove: 'Remover',
  picturePreviewTitle: 'Foto do item',
  picturePreviewLoading: 'Carregando foto…',
  picturePreviewError: 'Não foi possível carregar a foto',
  pictureOpenInDrive: 'Abrir no Drive',
  pictureClose: 'Fechar',
  pictureUploadSuccess: 'Foto atualizada',
  pictureUploadError: 'Falha ao enviar a foto',
  pictureRemoveSuccess: 'Foto removida',
  pictureRemoveError: 'Falha ao remover a foto',
  pictureInvalidType: 'Escolha uma imagem (JPEG, PNG, GIF ou WebP)',
  // List kind (create dialog)
  kindLabel: 'Tipo de lista',
  kindGeneric: 'Genérica',
  kindGroceries: 'Mercado',
  kindGroceriesHint: 'Cria categorias padrão de áreas do supermercado.',
  // Categories
  uncategorized: 'Outros',
  manageCategories: 'Categorias',
  manageCategoriesTitle: 'Gerenciar categorias',
  addCategory: 'Adicionar categoria',
  categoryNamePlaceholder: 'ex. Padaria',
  categoryNameRequired: 'O nome da categoria é obrigatório',
  noCategories: 'Nenhuma categoria ainda. Adicione uma para agrupar seus itens.',
  renameCategory: 'Renomear',
  deleteCategory: 'Excluir categoria',
  moveCategoryUp: 'Mover para cima',
  moveCategoryDown: 'Mover para baixo',
  saveCategory: 'Salvar',
  close: 'Fechar',
  assignCategory: 'Categoria',
  assignToCategory: 'Atribuir a categoria',
  removeFromCategory: 'Remover da categoria',
  toastCategoryCreated: 'Categoria adicionada',
  toastCategoryCreatedError: 'Falha ao adicionar a categoria',
  toastCategoryRenamed: 'Categoria renomeada',
  toastCategoryRenamedError: 'Falha ao renomear a categoria',
  toastCategoryDeleted: 'Categoria excluída',
  toastCategoryDeletedError: 'Falha ao excluir a categoria',
  toastCategoryReorderError: 'Falha ao reordenar as categorias',
  toastItemCategorized: 'Item movido',
  toastItemCategorizedError: 'Falha ao mover o item',
  // Ficha de detalhes do item (#364)
  detailSheetTitle: 'Detalhes do item',
  detailClose: 'Fechar',
  detailRenameLabel: 'Nome',
  detailRenamePlaceholder: 'Nome do item',
  detailCategoryLabel: 'Categoria',
  detailCategoryNone: 'Sem categoria',
  detailDueDateLabel: 'Data de vencimento',
  detailDueDateClear: 'Limpar vencimento',
  detailAssigneeLabel: 'Responsável',
  detailAssigneeNone: 'Sem responsável',
  detailImageLabel: 'Foto',
  detailDelete: 'Excluir item',
  detailsButtonLabel: 'Detalhes do item',
  toastItemRenamed: 'Item renomeado',
  toastItemRenamedError: 'Falha ao renomear o item',
  toastItemUpdated: 'Item atualizado',
  toastItemUpdatedError: 'Falha ao atualizar o item',
  toastItemDeleted: 'Item excluído',
  toastItemDeletedError: 'Falha ao excluir o item',
  // Menu de ações da lista (#364 PR3)
  listActions: 'Ações da lista',
  pasteItems: 'Colar itens',
  renameList: 'Renomear lista',
  deleteList: 'Excluir lista',
  renameListTitle: 'Renomear lista',
  save: 'Salvar',
  toastListRenamed: 'Lista renomeada',
  toastListRenamedError: 'Falha ao renomear a lista',
  deleteListConfirmTitle: 'Excluir esta lista?',
  deleteListConfirmDescription:
    'Isso remove permanentemente a lista e todos os seus itens. Não é possível desfazer.',
  deleteListConfirmAction: 'Excluir',
  toastListDeleted: 'Lista excluída',
  toastListDeletedError: 'Falha ao excluir a lista',
} as const;
